import type { PropsWithChildren, ReactNode } from 'react'
import { View } from 'react-native'

import { Image } from '@/src/elements/image'
import { TEST_ID } from '@/src/general/constants/testId'

import { PapaQuizBlock } from './PapaQuizBlock'
import { usePapaStyle } from './usePapaStyle'

type TPapaStyleProps = PropsWithChildren<{ testID?: string }>

export const PapaStyle = ({ children, testID }: TPapaStyleProps): ReactNode => {
  const { showPapaStyle } = usePapaStyle()

  return (
    <View testID={testID} className="min-w-screen max-w-screen relative flex-1">
      {showPapaStyle ? (
        <>
          <View
            testID={TEST_ID.PRAYER_SPACE.PAPA_STYLE_BACKGROUND}
            pointerEvents="none"
            className="absolute inset-0 bg-[#F0F4FA]"
          />
          <View className="absolute -right-4 lg:right-40 top-20 lg:top-12 h-60 w-60 flex-none opacity-15">
            <Image pointerEvents="none" source={require('@/img/leonxivfr/leonxivfr-logo.png')} contentFit="contain" />
          </View>
        </>
      ) : null}
      {children}
      {showPapaStyle ? <PapaQuizBlock /> : null}
    </View>
  )
}
